var exports = {
  "UU": "x93eb46d8--281cb5--name",
};

module.exports = exports;
